import * as type from './types';
// import * as type from "../announcement/types";
import axios from '../../../common/config/axios';

export const getDashboard = (data) => (dispatch) => {
    axios.get('dashboard', { params: data})
    .then((res) => {
        dispatch({
            type: type.GET_DASHBOARD,
            payload: res.data
        });
    })
    .catch((err) => {
        dispatch({
            type: type.GET_DASHBOARD,
            payload: []
        });
    });
}